function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconErrorNetwork = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h96v96H0z",
  "data-name": "Rectangle 1469",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1634"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 62.058V0h.323a62.06 62.06 0 0 1 61.735 62.057z",
  "data-name": "Intersection 3",
  style: {
    fill: "#f5f5f5"
  },
  transform: "rotate(-45 59.745 18.253)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 46.788V0a46.79 46.79 0 0 1 46.788 46.788z",
  "data-name": "Intersection 2",
  style: {
    fill: "#ddd"
  },
  transform: "rotate(-45 78.177 10.618)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 32.926V0a32.925 32.925 0 0 1 32.926 32.925H0z",
  "data-name": "Intersection 1",
  style: {
    fill: "#aaa"
  },
  transform: "rotate(-45 94.911 3.686)"
})));
export default SvgIconErrorNetwork;